import { v4 as uuidv4 } from 'uuid';

export default [
  {
    id: uuidv4(),
    title: 'Clientes',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Bilhetagem',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Arrecadação',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Equipe',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Operação',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Conectividade',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Planejamento',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Rede de Vendas',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Monitoramento',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Ajustes',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Relatórios',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Central de Integridade',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Atendimento',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Relacionamento',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Gerenciamento',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Validações',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Frota',
    open: false,
  },
  {
    id: uuidv4(),
    title: 'Benefícios',
    open: false,
  },
];
